import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowContainerFullStore } from "../../../../../store";
import { Grid } from "@mui/material";
import { OnlyPhoto } from "../../../../../../../libs/shared";

export const CierreContenedor = () => {

  return (
    <Grid
      container
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{ bgcolor: "white", pt: 2 }}
    >
      <CierreContenedorPhoto  />
      <CierreContenedorPhoto2  />
      <CierreContenedorPhoto3  />
    </Grid>
  );
};

const CierreContenedorPhoto = () => {
  const {
    open: openCierreContenedor1,
    handleClose: handleCloseCierreContenedor1,
    handleOpen: handleOpenCierreContenedor1,
  } = useOpen();

  const cierreContenedorPhoto1 = useWorkflowContainerFullStore(
    (state) => state.cierreContenedorPhoto1
  );

  const setCierreContenedorPhoto1 = useWorkflowContainerFullStore(
    (state) => state.setCierreContenedorPhoto1
  );
  const fotoUrl = useBlobUrl(cierreContenedorPhoto1);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseCierreContenedor1}
        handleOpen={handleOpenCierreContenedor1}
        label="CAJAS COMPLETAS"
        open={openCierreContenedor1}
        setFoto={setCierreContenedorPhoto1}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};

const CierreContenedorPhoto2 = () => {
  const {
    open: openCierreContenedor2,
    handleClose: handleCloseCierreContenedor2,
    handleOpen: handleOpenCierreContenedor2,
  } = useOpen();

  const cierreContenedorPhoto2 = useWorkflowContainerFullStore(
    (state) => state.cierreContenedorPhoto2
  );

  const setCierreContenedorPhoto2 = useWorkflowContainerFullStore(
    (state) => state.setCierreContenedorPhoto2
  );
  const fotoUrl = useBlobUrl(cierreContenedorPhoto2);

  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseCierreContenedor2}
        handleOpen={handleOpenCierreContenedor2}
        label="CAJAS / PUERTA"
        open={openCierreContenedor2}
        setFoto={setCierreContenedorPhoto2}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};

const CierreContenedorPhoto3 = () => {
  const {
    open: openCierreContenedor3,
    handleClose: handleCloseCierreContenedor3,
    handleOpen: handleOpenCierreContenedor3,
  } = useOpen();

  const cierreContenedorPhoto3 = useWorkflowContainerFullStore(
    (state) => state.cierreContenedorPhoto3
  );

  const setCierreContenedorPhoto3 = useWorkflowContainerFullStore(
    (state) => state.setCierreContenedorPhoto3
  );
  const fotoUrl = useBlobUrl(cierreContenedorPhoto3);


  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseCierreContenedor3}
        handleOpen={handleOpenCierreContenedor3}
        label="CONTENEDOR / CONDUCTOR"
        open={openCierreContenedor3}
        setFoto={setCierreContenedorPhoto3}
        width={220}
        fontSize={12}
      />
    </Grid>
  );
};
